// pages/mobile/MobileChrome.js
// Shared frame for the field staff pages: the bottom tab bar, the detail-page
// top bar and the loading / error states.
import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import { BackIcon, InboxIcon, PersonIcon } from './icons';
import { errorMessage } from './mobileApi';
import styles from './mobile.module.css';

export const TabBar = () => {
  const tabClass = ({ isActive }) => (isActive ? `${styles.tab} ${styles.tabActive}` : styles.tab);
  return (
    <nav aria-label="Main" className={styles.tabBar}>
      <NavLink to="/m" end className={tabClass}><InboxIcon />Messages</NavLink>
      <NavLink to="/m/me" className={tabClass}><PersonIcon />Me</NavLink>
    </nav>
  );
};

export const DetailTopBar = ({ title }) => (
  <header className={styles.topBar}>
    <Link to="/m" aria-label="Back to messages" className={styles.iconButton}><BackIcon /></Link>
    <h1 className={styles.topTitle}>{title}</h1>
    <span className={styles.iconSpacer} />
  </header>
);

export const LoadState = ({ loading, error, onRetry }) => {
  if (loading) return <p className={styles.loading}>Loading…</p>;
  return (
    <div className={styles.emptyState} role="alert">
      <p>{errorMessage(error)}</p>
      {onRetry && error?.response?.data?.error !== 'not_linked' && (
        <button type="button" className={styles.textButton} onClick={onRetry}>Try again</button>
      )}
    </div>
  );
};

export const StatusPill = ({ status, needsAnswer, neutralLabel = 'Seen' }) => {
  const normalized = (status || '').toLowerCase();
  if (needsAnswer) return <span className={`${styles.statusPill} ${styles.statusNeeds}`}>Needs your answer</span>;
  if (normalized === 'confirmed') return <span className={`${styles.statusPill} ${styles.statusConfirmed}`}>Confirmed</span>;
  if (normalized === 'denied') return <span className={`${styles.statusPill} ${styles.statusDenied}`}>Can't make it</span>;
  if (normalized === 'completed') return <span className={`${styles.statusPill} ${styles.statusConfirmed}`}>Completed</span>;
  return <span className={`${styles.statusPill} ${styles.statusNeutral}`}>{neutralLabel}</span>;
};
